export const paymentContactTranslations = {
    en: {
      bookYourYacht: "Book Your Yacht",
      bookingSteps: "Booking Steps:",
      steps: [
        "Choose your preferred contact method below",
        "Send us your booking details",
        "Receive payment instructions",
        "Complete your payment securely",
        "Get your booking confirmation"
      ],
      contactUsVia: "Contact Us Via:",
      contactMethods: {
        whatsapp: "WhatsApp",
        telegram: "Telegram",
        email: "Email"
      },
      noteTitle: "Note:",
      noteText: "Your booking will be confirmed after payment is received. For any questions, please don't hesitate to contact us."
    },
    tr: {
      bookYourYacht: "Yatınızı Rezerve Edin",
      bookingSteps: "Rezervasyon Adımları:",
      steps: [
        "Aşağıdan tercih ettiğiniz iletişim yöntemini seçin",
        "Bize rezervasyon detaylarınızı gönderin",
        "Ödeme talimatlarını alın",
        "Ödemenizi güvenli bir şekilde tamamlayın",
        "Rezervasyon onayınızı alın"
      ],
      contactUsVia: "Bize Şunlar Aracılığıyla Ulaşın:",
      contactMethods: {
        whatsapp: "WhatsApp",
        telegram: "Telegram",
        email: "E-posta"
      },
      noteTitle: "Not:",
      noteText: "Rezervasyonunuz ödeme alındıktan sonra onaylanacaktır. Herhangi bir sorunuz için lütfen bizimle iletişime geçmekten çekinmeyin."
    },
    de: {
      bookYourYacht: "Buchen Sie Ihre Yacht",
      bookingSteps: "Buchungsschritte:",
      steps: [
        "Wählen Sie unten Ihre bevorzugte Kontaktmethode",
        "Senden Sie uns Ihre Buchungsdetails",
        "Erhalten Sie Zahlungsanweisungen",
        "Schließen Sie Ihre Zahlung sicher ab",
        "Erhalten Sie Ihre Buchungsbestätigung"
      ],
      contactUsVia: "Kontaktieren Sie uns über:",
      contactMethods: {
        whatsapp: "WhatsApp",
        telegram: "Telegram",
        email: "E-Mail"
      },
      noteTitle: "Hinweis:",
      noteText: "Ihre Buchung wird nach Eingang der Zahlung bestätigt. Bei Fragen zögern Sie bitte nicht, uns zu kontaktieren."
    },
    ru: {
      bookYourYacht: "Забронировать вашу яхту",
      bookingSteps: "Шаги бронирования:",
      steps: [
        "Выберите предпочтительный способ связи ниже",
        "Отправьте нам детали вашего бронирования",
        "Получите инструкции по оплате",
        "Завершите оплату безопасно",
        "Получите подтверждение бронирования"
      ],
      contactUsVia: "Свяжитесь с нами через:",
      contactMethods: {
        whatsapp: "WhatsApp",
        telegram: "Telegram",
        email: "Электронная почта"
      },
      noteTitle: "Примечание:",
      noteText: "Ваше бронирование будет подтверждено после получения оплаты. Если у вас есть вопросы, пожалуйста, не стесняйтесь обращаться к нам."
    }
  };